import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { reviewsPostDataInterface } from 'src/_lib/interfaces/request-interfaces/review-It-popup.interface';
import { ProductService } from 'src/_lib/service/product.service';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { NgFor, NgIf } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { ReviewItSubmitPopupComponent } from './review-it-submit-popup/review-it-submit-popup.component';
import { environment } from 'src/environments/environment.prod';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { StarArrayPipe } from 'src/_lib/pipes/star-array.pipe';
import { BrowserService } from 'src/_lib/service/browser.service';

@Component({
  selector: 'app-review-it-popup',
  templateUrl: './review-it-popup.component.html',
  styleUrls: ['./review-it-popup.component.scss'],
  standalone: true,
  imports: [MatButtonModule, ReactiveFormsModule, NgIf, NgFor, NgxIntlTelInputModule, StarArrayPipe],
  encapsulation: ViewEncapsulation.None
})
export class ReviewItPopupComponent implements OnInit {
  isSubmitClicked: boolean = false;
  reviewItForm: FormGroup;
  productsreviewdata: any;
  product_key: number = null;
  productName: string = '';
  productImg: string = '';
  isSuccess: boolean = false;
  cdnImagePath = environment.cdnImagePath;
  commonImagePath: string = environment.commonImagePath;
  productReviews: any[] = [];
  avgRating: number = 0;
  reviewsCount: number = 0;

  constructor(
    private formBuilder: FormBuilder,
    private productHttp: ProductService,
    public dialogRef: MatDialogRef<ReviewItPopupComponent>,
    private dialog: MatDialog,
    private browser: BrowserService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.productReviews = data.reviews || [];
    this.avgRating = data.avgRating || 0;
    this.reviewsCount = data.reviewsCount || 0;
    this.productName = data.productName || '';
    this.product_key = data.product_key || null;
    this.productImg = data.productImg || '';
  }

  ngOnInit(): void {
    this.reviewItForm = this.formBuilder.group({
      first_name: ['', Validators.required],
      email_address: ['', [Validators.required, Validators.email]],
      title: ['', Validators.required],
      comments: ['', Validators.required],
      appearance: ['0', Validators.required],
      installation: ['0', Validators.required],
      price_value: ['0', Validators.required],
      quality: ['0', Validators.required],
      product_key: this.product_key
    });
  }

  closePopup(): void {
    this.dialogRef.close();
  }

  hiddenProductKey() {
    this.productsreviewdata = JSON.parse(this.browser.localStorage?.getItem('product-details'));
    this.product_key = this.productsreviewdata.product_key;
    return this.product_key;
  }

  submitReview() {
    this.isSubmitClicked = true;
    if (this.reviewItForm.valid) {
      this.isSubmitClicked = false;
      const data: reviewsPostDataInterface = this.reviewItForm.value;
      this.productHttp.reviewIt(data).subscribe(
        {
          next: (response) => {
            if (response[0].success === true) {
              this.closePopup();
              this.openReviewItPopUpSuccess();
              setTimeout(() => {
                this.resetForm();
                this.isSuccess = false;
              }, 4000);
            }
          },
          error: (error) => {
            this.isSubmitClicked = true;
            console.error('Form Submission error:', error);
          }
        }
      );
    }
    else {
      this.isSubmitClicked = true;
      console.error('Form is invalid');
    }
  }

  openReviewItPopUpSuccess(): void {
    const dialogRef = this.dialog.open(ReviewItSubmitPopupComponent, {
      width: '250px',
      data: { message: 'You have successfully signed up to get the best deals.' },
    });
    dialogRef.afterClosed().subscribe(() => { });
  }

  onImageError(event: Event): void {
    const target = event.target as HTMLImageElement;
    target.src = `${this.commonImagePath}image_not_found.webp`;
  }

  resetForm() {
    this.reviewItForm.reset({
      appearance: '0',
      installation: '0',
      price_value: '0',
      quality: '0'
    });
  }
}